import { render, staticRenderFns } from "./ElectricityPrice.vue?vue&type=template&id=47cc007c&scoped=true"
import script from "./ElectricityPrice.vue?vue&type=script&lang=js"
export * from "./ElectricityPrice.vue?vue&type=script&lang=js"
import style0 from "./ElectricityPrice.vue?vue&type=style&index=0&id=47cc007c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc007c",
  null
  
)

export default component.exports